'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeMessages = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mergeMessages = exports.mergeMessages = (0, _curry2.default)(function (newMessages, threadHistory) {
  return threadHistory.updateIn(_keyPaths.MESSAGES, (0, _pipe2.default)(function (existingMessages) {
    return newMessages.merge(existingMessages);
  }));
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/mergeMessages.js
// module id = 886
// module chunks = 2 3